export default "__VITE_ASSET__OggPVllY__"